import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {DatatableComponent, DataTableDataSource, GenericOption, GenericOptionGroup, WorkTypeService} from '@cas-hub/acabim-common-client';
import {DatePipe} from '@angular/common';
import {CategoryTableData, SubCategoryTableData} from '../work-order.model';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {WorkOrderSubCategoriesDataSource} from '../classes/work-subcategory-data-source.class';

@Component({
  selector: 'acabim-admin-work-order-subcategory-management',
  templateUrl: './work-order-subcategory-management.component.html',
  styleUrls: ['../styles.scss', './work-order-subcategory-management.component.scss']
})
export class WorkOrderSubcategoryManagementComponent implements OnInit {
  @ViewChild('subCategoryDataTable') public dataTable!: DatatableComponent;

  @Output() completed = new EventEmitter<any>();
  @Output() cancelled = new EventEmitter<any>();
  @Input() set workCategoryDetails(value: any) {
    if (value) {
      this.workCategory = value;
      if(this.workCategory && this.workCategory.id) {
        this.getData(this.workCategory.id);
      }
    }
  }
  @Input() cbiClassOptionsGrouped: GenericOptionGroup[] = [];
  @Input() cbiClassOptions: GenericOption[] = [];

  addWorkSubCategory = false;
  dataTableSources: DataTableDataSource<any>[] = [];
  isLoading = false;
  loadDetails = false;
  nullDate: Date = new Date('0001-01-01T00:00:00');
  selectedDetails: SubCategoryTableData | null = null;
  workCategory: CategoryTableData | null = null;

  constructor(
      private readonly workTypeService: WorkTypeService,
      private readonly datePipe: DatePipe
  ) { }

  ngOnInit(): void {}

  getData(workCategoryId: number): void {
    this.dataTableSources[0] = new WorkOrderSubCategoriesDataSource(
        'workCategory',
        this.dataRefresher(),
        undefined,
        undefined,
        action => {}
    );
    if (this.dataTable) {
      this.dataTable.requestImmediateDataRefresh();
    }
  }

  private dataRefresher(): () => Observable<SubCategoryTableData[]> {
    return () => {
      if (this.workCategory?.id && this.workCategory?.type_id) {
        return this.workTypeService.getSubCategories(this.workCategory.type_id, this.workCategory.id, {}).pipe(map(data => {
          return data.map(d => {
            const lmAsDate = d.last_modified ? new Date(d.last_modified) : null;
            const lmDate = lmAsDate && lmAsDate > this.nullDate ? this.datePipe.transform(lmAsDate, 'dd/MM/yyyy') as string : null;
            const out: SubCategoryTableData = {
              ...d,
              cbi_class_display: d.cbi_class ? d.cbi_class.id + ' – ' + d.cbi_class.name : '',
              status_display: d.status === 1 ? 'Active' : 'Inactive',
              last_modified_display: lmDate
            }
            return out as SubCategoryTableData;
          });
        }));
      }
      return new Observable<CategoryTableData[]>();
    };
  }

  showDetails(rowData: any): void {
    this.loadDetails = true;
  }

  add(): void {
    this.addWorkSubCategory = true;
  }

  closeDetailsModal(value: any) {
    // this.cancelled.emit(false);
    this.loadDetails = value;
  }

  closeAddModal(value: any) {
    // this.cancelled.emit(false);
    this.addWorkSubCategory = value;
  }

  completeDetailsModal(value: any) {
    this.addWorkSubCategory = false;
    this.dataTable.requestImmediateDataRefresh();
    this.loadDetails = false;
  }

  completeAddModal(value: any) {
    this.dataTable.requestImmediateDataRefresh();
    this.addWorkSubCategory = false;
    this.loadDetails = false;
  }

  cancel(): void {
    this.cancelled.emit(false);
  }

  setSelectedDetails(value: any) {
    this.selectedDetails = value;
  }

} // end of class
